import Splide from '@splidejs/splide';

const EL = '.js-reviews';

document.querySelectorAll(EL).forEach(sliderElement => {
  new Splide(sliderElement, {
    pagination: false,
    arrows: false,
    fixedWidth: '440px',
    gap: 40,
    breakpoints: {
      767: {
        gap: 15,
        fixedWidth: '280px',
      },
      1367: {
        gap: 20,
      },
    }
  }).mount();
});
